// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import NoticeUser from '../_raw/ui/icon_notice_user.svg';
import withIconProps from '../withIconProps';

export default withIconProps(NoticeUser);
